module.exports = __webpack_public_path__ + "static/media/yardnapha-gotten.52004b2c.png";